<template>
  <v-container>
    <v-row class="text-center my-4 py-4">
      <v-col>
        Welcome to Binder Registration. This is where you can register and
        deregister your library of binders for your accounts.
      </v-col>
    </v-row>
    <v-row class="text-center my-4 py-4">
      <v-col>
        <v-btn to="customers">Get Started</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home"
};
</script>
